(function() { window.GUID_ec663857_c4b7_461d_aecf_c154177d4992 = { getGuid: function() { return "ec663857-c4b7-461d-aecf-c154177d4992"; } }; })();
var CS;
(function (CS) {
    var Maths;
    (function (Maths) {
        //Permet de convertir un nombre d'une échelle à une autre
        //Exemple : J'ai une échelle de 0 à 10 et je veux convertir une valeur de cette échelle de 0 à 100
        // var num = 5
        // num.map(0,10,0,100)  //retourne 50
        function RangeConveter(value, in_min, in_max, out_min, out_max) {
            return (value - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
        }
        Maths.RangeConveter = RangeConveter;
    })(Maths = CS.Maths || (CS.Maths = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-math.js.map
